export default __webpack_public_path__ + "static/0153-3d6008290d3198a8a6f4132f2817e46f.png";